module.exports = __webpack_public_path__ + "img/bar-all.bbe8bc9c.svg";